import IconButton from 'LuxKit/Button/IconButton'
import ImageCarousel from 'LuxKit/Carousel/ImageCarousel'
import LineTimesIcon from 'LuxKit/Icons/line/LineTimesIcon'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { useScreenSizeUp } from 'hooks/useScreenSize'
import { rem } from 'polished'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import {
  SearchMapCardRoot,
  SearchMapCardImageContainer,
  searchMapCardImageParams,
} from './SearchMapCardStyles'

const ActionButtons = styled.div`
  position: absolute;
  top: ${rem(10)};
  right: ${rem(10)};
  display: flex;
  gap: ${rem(8)};
  z-index: 1;
`

const BookmarkWrapper = styled.div`
  && button {
    --button-icon-size: ${rem(16)};
  }
`

interface Props {
  images: Array<App.Image>
  onClose?: () => void
  bookmarkButton?: React.ReactNode
  imageBottomLeft?: React.ReactNode
  children: React.ReactNode
}

function SearchMapCardLayout(props: Props) {
  const {
    images,
    onClose,
    bookmarkButton,
    imageBottomLeft,
    children,
  } = props

  const isTabletScreenSizeAndUp = useScreenSizeUp('tablet')

  const handleClose = useCallback<React.MouseEventHandler<HTMLButtonElement>>((e) => {
    e.preventDefault()
    onClose?.()
  }, [onClose])

  return (
    <SearchMapCardRoot>
      <SearchMapCardImageContainer>
        <ImageCarousel
          arrowBehaviour={isTabletScreenSizeAndUp ? 'interaction-visible' : 'hidden'}
          images={images}
          imageParams={searchMapCardImageParams}
          eagerLoadFirstImage
          bottomLeft={imageBottomLeft}
        />
        <ActionButtons>
          {bookmarkButton && (
            <CSSBreakpoint max="mobile">
              <BookmarkWrapper>
                {bookmarkButton}
              </BookmarkWrapper>
            </CSSBreakpoint>
          )}
          {onClose && (
            <IconButton
              size="small"
              shape="circle"
              kind="primary"
              onClick={handleClose}
              variant="ghost"
            >
              <LineTimesIcon />
            </IconButton>
          )}
        </ActionButtons>
      </SearchMapCardImageContainer>
      {children}
    </SearchMapCardRoot>
  )
}

export default SearchMapCardLayout
